import { Image, ImageExtendedProps, Button } from "grommet";

export const CaseyImage: React.FC<ImageExtendedProps> = (props: ImageExtendedProps) => {
    return (<Button title="Casey took this picture!" onClick={() => window.open("https://caseyandersonphotography.pixieset.com/theengagementofjuliaandpurnam/", '_blank', 'rel=noopener noreferrer')}><Image role="presentation" className="casey-image" {...props}  /></Button>);
}